const ITEMS = [
  "PEOPLE",
  "RELATIONSHIPS",
  "OPPORTUNITIES",
  "GROWTH",
  "COMMERCIAL DEVELOPMENT",
  "NEW ZEALAND | AUSTRALIA",
  "THAT'S SORTD.",
];

export default function TrustMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="trust-marquee" className="bg-slate-50/60 border-y border-slate-100 py-7 overflow-hidden">
      <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-slate-400 mb-5">
        Trusted growth partner for SMEs, corporate &amp; real estate across NZ &amp; AU
      </p>
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-base font-bold tracking-[0.25em] text-slate-300 uppercase">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
